(function () {
    'use strict';

    angular
        .module('app.gameTracker')
        .component('sc3GameTrackerSummary', {
            templateUrl: 'app/game-tracker/summary/game-tracker-summary.component.html',
            controller: GameTrackerSummaryComponent,
            bindings: { 
                summary: '<'
            }
        });

    GameTrackerSummaryComponent.$inject = ['$uiRouterGlobals', 'holeSummaryStatisticType'];
    function GameTrackerSummaryComponent($uiRouterGlobals, holeSummaryStatisticType) {
        var ctrl = this;
        ctrl.showTables = !!$uiRouterGlobals.params.courseId;
        ctrl.statisticTypes = Object.values(holeSummaryStatisticType.$metadata);
        ctrl.holeNumbers = Array.from({ length: 18 }, function (_, i) { return i; });
    }
})();